import { createSlice } from '@reduxjs/toolkit'

const userSlice = createSlice({
  name: 'user',
  initialState: {},
  reducers: {
    setUser: (state, action) => {
      return action.payload
    },
    clearUser: (state) => {
      return {}
    }
  }
})

export const mydata = (state) => state.user;
export const { setUser, clearUser } = userSlice.actions
export default userSlice.reducer